import { SurchargeEventCalculationRun } from "../../../../shared/models/SurchargeEventCalculationRun";

const CalculatedEventRunsItem = (data: SurchargeEventCalculationRun) => {
  if (data) {
    return (
      <div className={data.approvedBy !== null ? "approved-surcharge-event" : ""}>
        {data.runTimeDate.toLocaleDateString("en-US")} - Update Day : {data.updateDay} - Run By : {data.runBy}
      </div>
    );
  } else {
    return <></>;
  }
};

export default CalculatedEventRunsItem;
